export default "__VITE_ASSET__CVk5UjHY__"